class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if (window.mediaNavSwiper) {
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e) {
        if (e.dataset.id == fetured_id) {
          window.mediaNavSwiper.slideTo(parseInt(e.dataset.index, 10) - 1, 500, false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if (document.querySelector('.product-addcart')){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var cartform = document.querySelector('.product-addcart').closest('form');
    const formData = new FormData(cartform);  
    config.body = formData;

    const title = this.getAttribute('data-pro-title') || '';
    const imgSrc = this.getAttribute('data-img-src') || '';

    const cartPopup = document.getElementById('cart-popup');
    const popupTitle = document.getElementById('cart-popup-title');
    const popupImage = document.getElementById('cart-popup-image');
    const popupClose = document.querySelector('.cart-popup-close');

    let popupTimer;


    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          popupTitle.textContent = title;
            popupImage.src = imgSrc;

            cartPopup.classList.remove('hidden');
            cartPopup.classList.add('visible');

            clearTimeout(popupTimer);
            popupTimer = setTimeout(() => {
              cartPopup.classList.remove('visible');
              setTimeout(() => cartPopup.classList.add('hidden'), 300);
            }, 3000);
          // setTimeout(function(e){
          //   document.querySelector('body').classList.add('open-drawer');
          // },500);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {

    });
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    // Destroy existing instances before reinitialising to prevent orphaned event listeners
    if (window.mediaThumbSwiper) { try { window.mediaThumbSwiper.destroy(true, true); } catch(e) {} window.mediaThumbSwiper = null; }
    if (window.mediaNavSwiper)   { try { window.mediaNavSwiper.destroy(true, true);   } catch(e) {} window.mediaNavSwiper   = null; }
    var swiper = window.mediaThumbSwiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      threshold: 5,
      breakpoints: {
        300: {
          direction: 'horizontal'
        },
        992: {
          direction: 'vertical',
        }
      }
    });
    var swiper2 = window.mediaNavSwiper = new Swiper(".media-nav", {
      loop: false,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".media-thumb-container .swiper-pagination",
        type: "fraction"
      },
      thumbs: {
        swiper: swiper,
      },
      breakpoints: {
        300: {
          direction: 'horizontal'
        },
        992: {
          direction: 'vertical'
        }
      }
    });
  }
}
try { product_slider(); } catch(e) { console.warn('product_slider error:', e); }
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  try { product_slider(); } catch(e) { console.warn('product_slider error:', e); }
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const toggleSets = document.querySelectorAll(".get-pro-set");

  toggleSets.forEach(toggleSet => {
    const listWrap = toggleSet.querySelector(".get-pro-list-wrap");
    const inner = toggleSet.querySelector(".get-pro-list-inner");
    const trigger = toggleSet.querySelector("a");

    if (!listWrap || !inner || !trigger) return;

    trigger.addEventListener("click", e => {
      e.preventDefault();
      const isActive = toggleSet.classList.toggle("active");
      listWrap.style.maxHeight = isActive ? inner.scrollHeight + "px" : 0;
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".variant-tab");
  const wrappers = document.querySelectorAll(".variants-multi-wrapper");
  const variantImages = document.querySelectorAll(".variant-image");
  const extraVariants = document.querySelectorAll(".extra-variant");
  const addToCartBtn = document.querySelector(".multi-pro-add-tocart");
  const bisBtn = document.querySelector(".multi-pro-bis-trigger");

  if (!tabs.length) return;

  function updateATCAttributes(el) {
    if (!el || !addToCartBtn) return;

    const varId = el.dataset.varId;
    const proTitle = el.dataset.proTitle;
    const imgSrc = el.dataset.imgSrc;
    const price = el.dataset.price;
    const comparePrice = el.dataset.comparePrice;
    const isAvailable = el.dataset.available !== 'false';

    addToCartBtn.dataset.varId = varId;
    addToCartBtn.dataset.proTitle = proTitle;
    addToCartBtn.dataset.imgSrc = imgSrc;

    // Keep BIS button in sync with the selected variant
    if (bisBtn) bisBtn.dataset.varId = varId;

    // Swap visibility: show ATC when available, show BIS button when sold out
    if (isAvailable) {
      addToCartBtn.classList.remove('d-none');
      if (bisBtn) bisBtn.classList.add('d-none');
    } else {
      addToCartBtn.classList.add('d-none');
      if (bisBtn) bisBtn.classList.remove('d-none');
    }

    // Update displayed price
    if (price) {
      document.querySelectorAll('.price-regular').forEach(el => el.textContent = price);
      document.querySelectorAll('.fixed-button-price').forEach(el => el.textContent = price);

      const comparePriceEls = document.querySelectorAll('.price-compare');
      if (comparePrice && comparePrice !== '0') {
        comparePriceEls.forEach(el => { el.textContent = comparePrice; el.style.display = ''; });
      } else {
        comparePriceEls.forEach(el => { el.textContent = ''; el.style.display = 'none'; });
      }
    }

    // Keep the hidden form input in sync so the form submits the correct variant
    const snippet = el.closest('.snippet-addto-cart');
    if (snippet && varId) {
      const input = snippet.querySelector('input[name="id"]');
      if (input) {
        input.value = varId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }


  /* ---------------- EV LIST CLICK HANDLER ---------------- */
  document.querySelectorAll("div.ev-list").forEach(list => {
    list.addEventListener("click", function () {

      // Remove active from siblings
      const parent = this.closest(".ev-wrap");
      if (parent) {
        parent.querySelectorAll(".ev-list").forEach(l => l.classList.remove("active"));
      }

      let price = this.getAttribute("data-price");
      if (price) {
        this.closest('.snippet-addto-cart')
          .querySelectorAll('.pdp-btn-price')
          .forEach(btn => btn.textContent = price);
      }

      // Add active to clicked
      this.classList.add("active");

      // Update ATC attributes
      updateATCAttributes(this);
    });
  });

  /* ---------------- TAB CLICK HANDLER ---------------- */
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const group = this.getAttribute("data-group");

      /* ---- PRICE UPDATE ---- */
      let price = this.getAttribute("data-price");
      if (price) {
        this.closest('.snippet-addto-cart')
          .querySelectorAll('.pdp-btn-price')
          .forEach(btn => btn.textContent = price);
      }

      /* ---- TAB ACTIVE ---- */
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      /* ---- WRAPPER SWITCH ---- */
      wrappers.forEach(w => w.classList.remove("active"));
      const activeWrapper = document.querySelector(`.variants-multi-wrapper[data-id="${group}"]`);
      if (activeWrapper) activeWrapper.classList.add("active");

      /* ---- MEDIA SLIDE ---- */
      if (window.mediaNavSwiper) {
        window.mediaNavSwiper.slideTo(group === 'refill' ? 1 : 0, 500);
      }

      /* ---- IMAGE SWITCH ---- */
      variantImages.forEach(img => img.classList.remove("active-image"));
      const activeImage = document.querySelector(`.variant-image[data-img-id="${group}"]`);
      if (activeImage) activeImage.classList.add("active-image");

      /* ---- EXTRA VARIANT SWITCH ---- */
      extraVariants.forEach(ex => ex.classList.remove("active-extra"));
      const matchExtra = document.querySelector(`.extra-variant[data-extra="${group}"]`);
      if (matchExtra) matchExtra.classList.add("active-extra");

      /* ---- SET FIRST EV-LIST OF MATCHED EXTRA TO ATC ---- */
      if (matchExtra) {
        // Prefer whichever ev-list is already active; only fall back to first if none is
        const alreadyActive = matchExtra.querySelector(".ev-list.active");
        const targetList = alreadyActive || matchExtra.querySelector(".ev-list");
        if (targetList) updateATCAttributes(targetList);

        // Ensure active class is correct (no-op if alreadyActive was found)
        matchExtra.querySelectorAll(".ev-list").forEach(l => l.classList.remove("active"));
        if (targetList) targetList.classList.add("active");
      }
    });
  });

  /* ---- CUSTOM DROPDOWNS (mobile inline + desktop fixed bar) ---- */
  function initDropdowns(wrap) {
    const typeDD = wrap.querySelector('.mobile-dropdown--type');
    const sizeDD = wrap.querySelector('.mobile-dropdown--size');
    if (!sizeDD) return;

    function openDD(dd) {
      const opts = dd.querySelector('.mobile-dropdown__options');
      const active = opts.querySelector('.mobile-dropdown__option.is-active');
      if (active) active.classList.add('d-none');
      dd.querySelector('.mobile-dropdown__trigger').setAttribute('aria-expanded', 'true');
      opts.classList.remove('d-none');
    }
    function closeDD(dd) {
      const opts = dd.querySelector('.mobile-dropdown__options');
      const active = opts.querySelector('.mobile-dropdown__option.is-active');
      if (active) active.classList.remove('d-none');
      dd.querySelector('.mobile-dropdown__trigger').setAttribute('aria-expanded', 'false');
      opts.classList.add('d-none');
    }
    function toggleDD(dd) {
      dd.querySelector('.mobile-dropdown__trigger').getAttribute('aria-expanded') === 'true' ? closeDD(dd) : openDD(dd);
    }

    // Type trigger (only when type DD exists)
    if (typeDD) {
    typeDD.querySelector('.mobile-dropdown__trigger').addEventListener('click', () => { toggleDD(typeDD); closeDD(sizeDD); });

    // Type option click
    typeDD.querySelectorAll('.mobile-dropdown__option:not(.variant-metafield').forEach(opt => {
      opt.addEventListener('click', function () {
        const group = this.dataset.value;
        typeDD.querySelectorAll('.mobile-dropdown__option').forEach(o => { o.classList.remove('is-active'); o.classList.remove('d-none'); });
        this.classList.add('is-active');
        typeDD.querySelector('.mobile-dropdown__label').textContent = this.textContent.trim();
        closeDD(typeDD);

        // Show relevant size options
        sizeDD.querySelectorAll('.mobile-size-option').forEach(o => {
          o.classList.remove('is-active');
          o.dataset.typeGroup === group ? o.classList.remove('d-none') : o.classList.add('d-none');
        });

        // Auto-select first of new group
        const first = sizeDD.querySelector(`.mobile-size-option[data-type-group="${group}"]`);
        if (first) {
          first.classList.add('is-active');
          sizeDD.querySelector('.mobile-dropdown__label').textContent = first.textContent.trim();
          updateATCAttributes(first);
        }

        // Sync desktop tab
        tabs.forEach(t => t.classList.remove('active'));
        const matchTab = document.querySelector(`.variant-tab[data-group="${group}"]`);
        if (matchTab) matchTab.classList.add('active');

        // Sync wrappers & extras
        wrappers.forEach(w => w.classList.remove('active'));
        const matchWrapper = document.querySelector(`.variants-multi-wrapper[data-id="${group}"]`);
        if (matchWrapper) matchWrapper.classList.add('active');
        extraVariants.forEach(ex => ex.classList.remove('active-extra'));
        const matchExtra = document.querySelector(`.extra-variant[data-extra="${group}"]`);
        if (matchExtra) matchExtra.classList.add('active-extra');

        if (window.mediaNavSwiper) window.mediaNavSwiper.slideTo(group === 'refill' ? 1 : 0, 500);

        // Sync the other dropdown instance's type label
        document.querySelectorAll('.mobile-variant-dropdowns').forEach(otherWrap => {
          if (otherWrap === wrap) return;
          const otherTypeDD = otherWrap.querySelector('.mobile-dropdown--type');
          if (!otherTypeDD) return;
          otherTypeDD.querySelectorAll('.mobile-dropdown__option').forEach(o => { o.classList.remove('is-active'); o.classList.remove('d-none'); });
          const otherMatch = otherTypeDD.querySelector(`.mobile-dropdown__option[data-value="${group}"]`);
          if (otherMatch) {
            otherMatch.classList.add('is-active');
            const otherLabel = otherTypeDD.querySelector('.mobile-dropdown__label');
            if (otherLabel) otherLabel.textContent = otherMatch.textContent.trim();
          }
          // Also sync size options visibility in the other instance
          const otherSizeDD = otherWrap.querySelector('.mobile-dropdown--size');
          if (otherSizeDD) {
            otherSizeDD.querySelectorAll('.mobile-size-option').forEach(o => {
              o.classList.remove('is-active');
              o.dataset.typeGroup === group ? o.classList.remove('d-none') : o.classList.add('d-none');
            });
            const otherFirst = otherSizeDD.querySelector(`.mobile-size-option[data-type-group="${group}"]`);
            if (otherFirst) {
              otherFirst.classList.add('is-active');
              const otherSizeLabel = otherSizeDD.querySelector('.mobile-dropdown__label');
              if (otherSizeLabel) otherSizeLabel.textContent = otherFirst.textContent.trim();
            }
          }
        });
      });
    });
    } // end if (typeDD)

    // Size trigger
    sizeDD.querySelector('.mobile-dropdown__trigger').addEventListener('click', () => { toggleDD(sizeDD); if (typeDD) closeDD(typeDD); });

    // Size option click
    sizeDD.querySelectorAll('.mobile-size-option').forEach(opt => {
      opt.addEventListener('click', function () {
        sizeDD.querySelectorAll('.mobile-size-option').forEach(o => { o.classList.remove('is-active'); o.classList.remove('d-none'); });
        // re-hide options that don't belong to current group (only relevant when type DD exists)
        const currentGroup = typeDD?.querySelector('.mobile-dropdown__option.is-active')?.dataset.value;
        if (currentGroup) {
          sizeDD.querySelectorAll('.mobile-size-option').forEach(o => {
            if (o.dataset.typeGroup !== currentGroup) o.classList.add('d-none');
          });
        }
        this.classList.add('is-active');
        sizeDD.querySelector('.mobile-dropdown__label').textContent = this.textContent.trim();
        closeDD(sizeDD);
        updateATCAttributes(this);

        // Sync the other dropdown instance's size label
        const selectedVarId = this.dataset.varId;
        document.querySelectorAll('.mobile-variant-dropdowns').forEach(otherWrap => {
          if (otherWrap === wrap) return;
          const otherSizeDD = otherWrap.querySelector('.mobile-dropdown--size');
          if (!otherSizeDD) return;
          otherSizeDD.querySelectorAll('.mobile-size-option').forEach(o => o.classList.remove('is-active'));
          const otherMatch = otherSizeDD.querySelector(`.mobile-size-option[data-var-id="${selectedVarId}"]`);
          if (otherMatch) {
            otherMatch.classList.add('is-active');
            const otherLabel = otherSizeDD.querySelector('.mobile-dropdown__label');
            if (otherLabel) otherLabel.textContent = otherMatch.textContent.trim();
          }
        });
      });
    });

    // Close on outside click
    document.addEventListener('click', e => {
      if (typeDD && !typeDD.contains(e.target)) closeDD(typeDD);
      if (!sizeDD.contains(e.target)) closeDD(sizeDD);
    });

    // Init: apply first active size label
    const firstSize = sizeDD.querySelector('.mobile-size-option.is-active[data-type-group="bottle"]')
      || sizeDD.querySelector('.mobile-size-option.is-active');
    if (firstSize) {
      sizeDD.querySelector('.mobile-dropdown__label').textContent = firstSize.textContent.trim();
      updateATCAttributes(firstSize);
    }
  }

  // Init inline mobile dropdown (mobile only)
  const mobileWrap = document.querySelector('.variant-type-tabs-wrap .mobile-variant-dropdowns');
  if (mobileWrap && window.innerWidth < 992) initDropdowns(mobileWrap);

  // Init fixed-bar desktop dropdown (desktop only, always in DOM)
  const fixedBarWrap = document.querySelector('.fixed-button-dropdown .mobile-variant-dropdowns');
  if (fixedBarWrap && window.innerWidth >= 992) initDropdowns(fixedBarWrap);
});

if (document.querySelector('.multi-pro-add-tocart')) {
  document.querySelector('.multi-pro-add-tocart').addEventListener('click', function (evt) {
    evt.preventDefault();

    const selectedVarId = this.dataset.varId;
    const title = this.dataset.proTitle || '';
    const imgSrc = this.dataset.imgSrc || '';

    const cartPopup = document.getElementById('cart-popup');
    const popupTitle = document.getElementById('cart-popup-title');
    const popupImage = document.getElementById('cart-popup-image');
    const popupClose = document.querySelector('.cart-popup-close');

    let popupTimer;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', selectedVarId);
    formData.append('quantity', 1); 
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(() => {
            document.querySelector('.product-form-error').innerHTML = '';
          }, 2000);
          return;
        }

        if (typeof load_cart == 'function') {
          load_cart();

          popupTitle.textContent = title;
          popupImage.src = imgSrc;

          cartPopup.classList.remove('hidden');
          cartPopup.classList.add('visible');

          clearTimeout(popupTimer);
          popupTimer = setTimeout(() => {
            cartPopup.classList.remove('visible');
            setTimeout(() => cartPopup.classList.add('hidden'), 300);
          }, 3000);
        } else {
          window.location.href = "/cart";
        }
      })
      .catch((e) => console.error(e));
  });
}



// ============================ discover set 

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".discover-add-to-cart")){
     const wrappers = document.querySelectorAll(".discovery-set-wrapper");
      const addToCartBtn = document.querySelector(".discover-add-to-cart");

      // --- Toggle dropdown visibility ---
      document.querySelectorAll(".discovery-set-title").forEach(title => {
        title.addEventListener("click", function () {
          const dropWrap = this.nextElementSibling;
          const isOpen = dropWrap.classList.contains("open");

          // Close all dropdowns
          document.querySelectorAll(".discovery-set-drop-wrap").forEach(w => {
            w.classList.remove("open");
            lenis.start();
            if (window.innerWidth > 991) {
              w.style.maxHeight = "0px";
              w.style.opacity = "0";
              w.style.visibility = "hidden";
            }
            w.previousElementSibling.classList.remove("active-title"); // remove active from title
          });


          dropWrap.addEventListener('wheel', (e) => {
            // allow normal scroll inside sidebar
            e.stopPropagation();
          }, { passive: false });

          dropWrap.addEventListener('touchstart', (e) => {
            e.stopPropagation();
          }, { passive: false });

          dropWrap.addEventListener('touchmove', (e) => {
            e.stopPropagation();
          }, { passive: false });

          // Toggle the clicked one
          if (!isOpen) {
            dropWrap.classList.add("open");
            lenis.stop();
            if (window.innerWidth > 991) {
              dropWrap.style.maxHeight = dropWrap.scrollHeight + "px";
              dropWrap.style.opacity = "1";
              dropWrap.style.visibility = "visible";
            }else{
              dropWrap.style.visibility = "visible";
              dropWrap.style.opacity = "1";
              dropWrap.style.maxHeight = "100vh";
            }
            this.classList.add("active-title");


          }
        });
      });

      // Close button click
      document.querySelectorAll(".close-popup").forEach(closeBtn => {
        closeBtn.addEventListener("click", function (e) {
          e.preventDefault();
          lenis.start();
          const dropWrap = this.closest(".discovery-set-drop-wrap");
          dropWrap.classList.remove("open");
          if (window.innerWidth > 991) {
            dropWrap.style.maxHeight = "0px";
            dropWrap.style.opacity = "0";
            dropWrap.style.visibility = "hidden";
          }
          const title = dropWrap.previousElementSibling;
          title.classList.remove("active-title");
        });
      });


 



  // --- Handle scent selection ---
  wrappers.forEach(wrapper => {
    wrapper.querySelectorAll("li.discover-set-pro").forEach(li => {
      li.addEventListener("click", function () {
        lenis.start();
        const selectedId = this.dataset.id;
        const titleEl = wrapper.querySelector(".discovery-set-title");

        // Reset others
        wrapper.querySelectorAll("li").forEach(l => l.classList.remove("active"));
        this.classList.add("active");

        // Update title text
        // titleEl.querySelector("span")?.remove();
        // titleEl.querySelector(".dis-new-title").innerHTML = this.textContent;
        // titleEl.classList.add("active-pro");
        const titleText = titleEl.querySelector(".dis-new-title");
        if (titleText) titleText.textContent = this.textContent;
        titleEl.classList.add("active-pro");

        titleEl.dataset.variantId = selectedId;

        // Close dropdown
        const dropWrap = wrapper.querySelector(".discovery-set-drop-wrap");
        dropWrap.classList.remove("open");
        dropWrap.style.maxHeight = "0px";
        dropWrap.style.opacity = "0";
        dropWrap.style.visibility = "hidden";

        // Enable Add to Cart if all selected
        const allSelected = [...wrappers].every(w =>
          w.querySelector(".discovery-set-title.active-pro")
        );
        addToCartBtn.disabled = !allSelected;
      });
    });
  });

  // --- Add to cart ---
  addToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const selectedVariants = [...wrappers]
      .map(w => w.querySelector(".discovery-set-title").dataset.variantId)
      .filter(id => id);

    if (selectedVariants.length === 0) return;

    console.log("selectedVariants",selectedVariants);
      (async () => {
      for (const id of selectedVariants) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, quantity: 1 }),
        });
      }

      const res = await fetch("/cart.js");
      const data = await res.json();

      load_cart();
      document.querySelector(".cart-count").innerHTML = data.item_count;

      // --- CART POPUP ---
      const cartPopup = document.getElementById("cart-popup");
      const popupTitle = document.getElementById("cart-popup-title");
      const popupImage = document.getElementById("cart-popup-image");
      const popupClose = document.querySelector(".cart-popup-close");
      const discover_title = document.querySelector(".main-discover-set-wrapper");
      

      let popupTimer;

      if (cartPopup && popupTitle && popupImage) {
        popupTitle.textContent = discover_title.getAttribute('data-title');
        popupImage.src = discover_title.getAttribute('data-img-src');

        cartPopup.classList.remove("hidden");
        cartPopup.classList.add("visible");

        clearTimeout(popupTimer);
        popupTimer = setTimeout(() => {
          cartPopup.classList.remove("visible");
          setTimeout(() => cartPopup.classList.add("hidden"), 300);
        }, 3000);
      }

      if (popupClose && !popupClose.hasListener) {
        popupClose.addEventListener("click", function () {
          clearTimeout(popupTimer);
          cartPopup.classList.remove("visible");
          setTimeout(() => cartPopup.classList.add("hidden"), 300);
        });
        popupClose.hasListener = true;
      }
    })();

  });
  }
});



if (screen.width < 992) {
  const mobileTrigger = document.querySelector(".mobile-multi-size");
  const closeBtn = document.querySelector(".close-popup");

  if (mobileTrigger) {
    mobileTrigger.addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.add("open-mobile-var");
      lenis.stop();
    });
  }

  if(closeBtn) document.querySelectorAll('.close-popup').forEach(function(closePopup){
    closePopup.addEventListener("click", function(e){
      e.preventDefault();
      document.body.classList.remove("open-mobile-var");
      lenis.start();
    });
  });
}


//  document.querySelectorAll('.multi-variants .variant-grid').forEach(function (sizeList) {
//   if(sizeList.dataset.listenerAttached === 'true') return;
//   sizeList.dataset.listenerAttached = 'true';

//   sizeList.addEventListener('click', function (e) {
//     e.preventDefault();
//     let variant_id = sizeList.dataset.id;
//     let error_grid_outer = sizeList.closest('.variants-multi-wrapper');
//     let error_grid = error_grid_outer.querySelector('.grid-error');

//     let formData = {
//       items: [
//         {
//           id: variant_id,
//           quantity: 1,
//         },
//       ],
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         // ----- Handle Error -----
//         if (data.status == 422) {
//           error_grid.innerHTML = data.description;
//           setTimeout(function () {
//             error_grid.innerHTML = '';
//           }, 2000);
//           return;
//         }

//         // ----- If Success -----
//         if (document.location.href.indexOf('/cart') > -1) {
//           window.location.href = '/cart';
//         } else {
//           if (typeof load_cart == 'function') {
//             document.body.classList.remove('open-mobile-var');
//             setTimeout(() => {
//               load_cart();
//             }, 1000);
//             // setTimeout(function () {
//             //   document.querySelector('body').classList.add('open-drawer');
//             // }, 500);
//           } else {
//             window.location.href = '/cart';
//           }
//         }

//         // ----- Update Cart Count -----
//         fetch('/cart.js')
//           .then((resp) => resp.json())
//           .then(function (data) {
//             var cart_count = data.item_count;
//             document.querySelector('.cart-count').innerHTML = cart_count;
//           })
//           .catch(function (error) {
//             console.log(error);
//           });

//         // ----- CART NOTIFICATION -----
//         const title = sizeList.getAttribute('data-pro-title') || '';
//         const imgSrc = sizeList.getAttribute('data-img-src') || '';

//         const cartPopup = document.getElementById('cart-popup');
//         const popupTitle = document.getElementById('cart-popup-title');
//         const popupImage = document.getElementById('cart-popup-image');
//         const popupClose = document.querySelector('.cart-popup-close');

//         let popupTimer;

//         if (cartPopup && popupTitle && popupImage) {
//           popupTitle.textContent = title;
//           popupImage.src = imgSrc;

//           // Show popup
//           cartPopup.classList.remove('hidden');
//           cartPopup.classList.add('visible');

//           clearTimeout(popupTimer);

//           // Hide after 3s
//           popupTimer = setTimeout(() => {
//             cartPopup.classList.remove('visible');
//             setTimeout(() => cartPopup.classList.add('hidden'), 300);
//           }, 3000);
//         }

//         // Manual close (attach once)
//         if (popupClose && !popupClose.hasListener) {
//           popupClose.addEventListener('click', function () {
//             clearTimeout(popupTimer);
//             cartPopup.classList.remove('visible');
//             setTimeout(() => cartPopup.classList.add('hidden'), 300);
//           });
//           popupClose.hasListener = true;
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   });
// });



// Dock/undock the sticky add-to-cart when the anchor enters the viewport.
// rootMargin: '0px 0px -1px 0px' fires the instant the anchor's top edge
// crosses the bottom of the viewport, preventing any visual flash.
(function () {
  const snippetBtn = document.querySelector('.product-main-add-to-cart');
  const anchor = document.querySelector('.addto-cart-anchor');

  // Anchor observer — docks the button in-place when scrolled to it
  if (snippetBtn && anchor) {
    const TRANSITION_MS = 300;

    // Spacer: prevents layout shift when button toggles between in-flow (docked)
    // and position:fixed. Shown when button is fixed (fills the vacated space),
    // hidden when button is docked (button itself occupies the space).
    // Both show/hide happen in the same synchronous paint frame as the class change.
    const spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.cssText = 'display:none;pointer-events:none;flex-shrink:0;';
    snippetBtn.parentNode.insertBefore(spacer, snippetBtn);
    const showSpacer = () => {
      spacer.style.height = snippetBtn.offsetHeight + 'px';
      spacer.style.display = 'block';
    };
    const hideSpacer = () => { spacer.style.display = 'none'; };

    let isDesktopAnimating = false;
    let observerLocked = false;
    let observerLockTimer = null;

    const lockObserver = () => {
      observerLocked = true;
      clearTimeout(observerLockTimer);
      // Lock for the full animation + a small buffer to let the layout settle
      observerLockTimer = setTimeout(() => { observerLocked = false; }, TRANSITION_MS + 150);
    };

    const desktopSlideOut = () => {
      if (!snippetBtn.classList.contains('fixed-add-to-cart-desktop')) return;
      if (isDesktopAnimating) return;
      lockObserver();
      isDesktopAnimating = true;
      snippetBtn.style.transform = 'translateY(-100%)';
      snippetBtn.style.opacity = '0';
      setTimeout(() => {
        // Hide spacer and return button to flow in the same paint frame — zero shift
        hideSpacer();
        snippetBtn.classList.remove('fixed-add-to-cart-desktop');
        snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price, .fixed-button-dropdown, .fixed-button-title').forEach(el => el.classList.add('d-none'));
        snippetBtn.style.transform = '';
        snippetBtn.style.opacity = '';
        isDesktopAnimating = false;
      }, TRANSITION_MS);
    };

    const syncFixedBarDropdown = () => {
      const fbWrap = document.querySelector('.fixed-button-dropdown .mobile-variant-dropdowns');
      if (!fbWrap) return;
      const typeDD = fbWrap.querySelector('.mobile-dropdown--type');
      const sizeDD = fbWrap.querySelector('.mobile-dropdown--size');
      if (!sizeDD) return;

      // Determine active var-id from the ATC button
      const atcBtn = document.querySelector('.multi-pro-add-tocart');
      const activeVarId = atcBtn?.dataset.varId;

      if (typeDD) {
        // Determine active type from desktop tabs (or mobile inline type DD)
        const activeTab = document.querySelector('.variant-tab.active');
        const activeGroup = activeTab?.dataset.group ||
          document.querySelector('.variant-type-tabs-wrap .mobile-dropdown--type .mobile-dropdown__option.is-active')?.dataset.value ||
          'bottle';

        // Sync type dropdown label + active option
        typeDD.querySelectorAll('.mobile-dropdown__option').forEach(o => {
          o.classList.remove('is-active', 'd-none');
          if (o.dataset.value === activeGroup) o.classList.add('is-active');
        });
        const typeLabelEl = typeDD.querySelector('.mobile-dropdown__label');
        const activeTypeOpt = typeDD.querySelector('.mobile-dropdown__option.is-active');
        if (typeLabelEl && activeTypeOpt) typeLabelEl.textContent = activeTypeOpt.textContent.trim();

        // Show size options for active group; hide others
        sizeDD.querySelectorAll('.mobile-size-option').forEach(o => {
          o.classList.remove('is-active');
          o.dataset.typeGroup === activeGroup ? o.classList.remove('d-none') : o.classList.add('d-none');
        });

        // Mark matching size option as active
        const matchSize = activeVarId
          ? sizeDD.querySelector(`.mobile-size-option[data-var-id="${activeVarId}"]`)
          : sizeDD.querySelector(`.mobile-size-option[data-type-group="${activeGroup}"]`);
        if (matchSize) {
          matchSize.classList.add('is-active');
          const sizeLabelEl = sizeDD.querySelector('.mobile-dropdown__label');
          if (sizeLabelEl) sizeLabelEl.textContent = matchSize.textContent.trim();
        }
      } else {
        // Single-type product (no bottle/refill split) — just sync active size
        sizeDD.querySelectorAll('.mobile-size-option').forEach(o => o.classList.remove('is-active'));
        const matchSize = activeVarId
          ? sizeDD.querySelector(`.mobile-size-option[data-var-id="${activeVarId}"]`)
          : sizeDD.querySelector('.mobile-size-option');
        if (matchSize) {
          matchSize.classList.add('is-active');
          const sizeLabelEl = sizeDD.querySelector('.mobile-dropdown__label');
          if (sizeLabelEl) sizeLabelEl.textContent = matchSize.textContent.trim();
        }
      }
    };

    const desktopSlideIn = () => {
      if (snippetBtn.classList.contains('fixed-add-to-cart-desktop')) return;
      syncFixedBarDropdown();
      lockObserver();
      isDesktopAnimating = true;
      // Start hidden above
      snippetBtn.style.transition = 'none';
      snippetBtn.style.transform = 'translateY(-100%)';
      snippetBtn.style.opacity = '0';
      snippetBtn.classList.add('fixed-add-to-cart-desktop');
      showSpacer(); // fills flow gap left by button going fixed — same paint frame
      snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price, .fixed-button-dropdown, .fixed-button-title').forEach(el => el.classList.remove('d-none'));
      // Force reflow then animate in
      snippetBtn.getBoundingClientRect();
      snippetBtn.style.transition = '';
      snippetBtn.style.transform = '';
      snippetBtn.style.opacity = '';
      setTimeout(() => {
        isDesktopAnimating = false;
      }, TRANSITION_MS);
    };

    let anchorObserverInitialized = false;

    const anchorObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isDesktop = window.innerWidth >= 992;

          // Suppress callbacks during layout-shifting transitions to prevent feedback loops
          if (observerLocked) return;

          // On the very first callback (page load), silently set initial state without animating
          if (!anchorObserverInitialized) {
            anchorObserverInitialized = true;
            if (isDesktop && !entry.isIntersecting && entry.boundingClientRect.top < 0) {
              // Page loaded already scrolled past anchor — apply class silently, no animation
              snippetBtn.style.transition = 'none';
              snippetBtn.classList.add('fixed-add-to-cart-desktop');
              showSpacer(); // hold in-page position while button is fixed
              snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price, .fixed-button-dropdown').forEach(el => el.classList.remove('d-none'));
              snippetBtn.getBoundingClientRect();
              snippetBtn.style.transition = '';
            } else if (!isDesktop && entry.isIntersecting) {
              // Mobile: anchor visible on load — dock instantly, no animation
              snippetBtn.style.transition = 'none';
              snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.add('d-none'));
              const innerBtn = snippetBtn.querySelector('.button');
              if (innerBtn) innerBtn.style.justifyContent = '';
              snippetBtn.classList.add('docked');
              hideSpacer(); // button is in flow, spacer not needed
              snippetBtn.style.opacity = '';
              snippetBtn.style.transform = '';
              snippetBtn.getBoundingClientRect();
              snippetBtn.style.transition = '';
            }
            return;
          }

          if (entry.isIntersecting) {
            // Step 2: Anchor is visible — revert step-3 styles and dock the button
            if (isDesktop) {
              if (!isDesktopAnimating) desktopSlideOut();
            } else {
              // Detect if we're coming from step 3 (img/price visible = scrolling UP)
              const fromStep3 = snippetBtn.querySelector('.fixed-button-img') &&
                !snippetBtn.querySelector('.fixed-button-img').classList.contains('d-none');
              if (fromStep3) {
                // Slide the fixed bar down smoothly before docking (issue 2)
                snippetBtn.style.opacity = '0';
                snippetBtn.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  snippetBtn.style.transition = 'none';
                  snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.add('d-none'));
                  const innerBtn = snippetBtn.querySelector('.button');
                  if (innerBtn) innerBtn.style.justifyContent = '';
                  snippetBtn.style.opacity = '';
                  snippetBtn.style.transform = '';
                  snippetBtn.classList.add('docked');
                  hideSpacer(); // button back in flow, spacer not needed — same paint
                  snippetBtn.getBoundingClientRect();
                  snippetBtn.style.transition = '';
                }, TRANSITION_MS);
              } else {
                // Snap to docked — coming from step 1, no animation needed
                snippetBtn.style.transition = 'none';
                snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.add('d-none'));
                const innerBtn = snippetBtn.querySelector('.button');
                if (innerBtn) innerBtn.style.justifyContent = '';
                snippetBtn.style.opacity = '';
                snippetBtn.style.transform = '';
                snippetBtn.classList.add('docked');
                hideSpacer(); // button back in flow — same paint
                snippetBtn.getBoundingClientRect();
                snippetBtn.style.transition = '';
              }
            }
          } else {
            if (isDesktop) {
              if (!isDesktopAnimating) {
                if (entry.boundingClientRect.top < 0) {
                  // Step 3 (desktop): Anchor exited above — slide in from top
                  desktopSlideIn();
                } else {
                  // Step 1 (desktop): Anchor exited below — slide out to top
                  desktopSlideOut();
                }
              }
            } else {
              const innerBtn = snippetBtn.querySelector('.button');
              if (entry.boundingClientRect.top < 0) {
                // Step 3 (mobile): Anchor exited above — slide up from bottom with img/price
                showSpacer(); // prevents layout shift when button leaves flow — same paint
                snippetBtn.style.transition = 'none';
                snippetBtn.style.opacity = '0';
                snippetBtn.style.transform = 'translateY(100%)';
                snippetBtn.classList.remove('docked');
                snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.remove('d-none'));
                if (innerBtn) innerBtn.style.justifyContent = 'space-between';
                snippetBtn.getBoundingClientRect();
                snippetBtn.style.transition = '';
                snippetBtn.style.opacity = '';
                snippetBtn.style.transform = '';
              } else {
                // Step 1 (mobile): Anchor exited below — snap to fixed, no animation (issue 3)
                showSpacer(); // prevents layout shift — same paint
                snippetBtn.style.transition = 'none';
                snippetBtn.classList.remove('docked');
                snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.add('d-none'));
                if (innerBtn) innerBtn.style.justifyContent = '';
                snippetBtn.style.opacity = '';
                snippetBtn.style.transform = '';
                snippetBtn.getBoundingClientRect();
                snippetBtn.style.transition = '';
              }
            }
          }
        });
      },
      { threshold: 0, rootMargin: `0px 0px -${snippetBtn.offsetHeight}px 0px` }
    );
    anchorObserver.observe(anchor);

    // Product-wrap observer — two jobs:
    // 1. Scrolling UP from step 3: when .product-wrap re-enters the viewport,
    //    smoothly dock the button (step 3 → step 2). Locks the anchor observer
    //    to prevent a duplicate transition.
    // 2. Scrolling DOWN past .product-wrap: when it exits above the viewport,
    //    ensure the sticky button is in step 3 (handles the edge case where the
    //    button was docked by this observer and the anchor state never changed).
    const productWrap = document.querySelector('.product-wrap');
    if (productWrap) {
      const productWrapObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const isDesktop = window.innerWidth >= 992;

            if (!entry.isIntersecting) {
              // product-wrap exited above → we've scrolled down past it → step 3
              if (entry.boundingClientRect.top >= 0) return; // exited below, ignore
              if (isDesktop) {
                if (!isDesktopAnimating && !snippetBtn.classList.contains('fixed-add-to-cart-desktop')) {
                  desktopSlideIn();
                }
              } else {
                // Only act if button is currently docked (we put it there)
                if (!snippetBtn.classList.contains('docked')) return;
                showSpacer();
                snippetBtn.style.transition = 'none';
                snippetBtn.style.opacity = '0';
                snippetBtn.style.transform = 'translateY(100%)';
                snippetBtn.classList.remove('docked');
                snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.remove('d-none'));
                const innerBtn = snippetBtn.querySelector('.button');
                if (innerBtn) innerBtn.style.justifyContent = 'space-between';
                snippetBtn.getBoundingClientRect();
                snippetBtn.style.transition = '';
                snippetBtn.style.opacity = '';
                snippetBtn.style.transform = '';
              }
              return;
            }

            // product-wrap is entering viewport (scrolling UP from step 3)
            if (isDesktop) {
              if (!isDesktopAnimating && snippetBtn.classList.contains('fixed-add-to-cart-desktop')) {
                desktopSlideOut();
              }
            } else {
              const fromStep3 = snippetBtn.querySelector('.fixed-button-img') &&
                !snippetBtn.querySelector('.fixed-button-img').classList.contains('d-none');
              if (fromStep3) {
                lockObserver(); // prevent anchor observer from firing the same animation in parallel
                snippetBtn.style.opacity = '0';
                snippetBtn.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  snippetBtn.style.transition = 'none';
                  snippetBtn.querySelectorAll('.fixed-button-img, .fixed-button-price').forEach(el => el.classList.add('d-none'));
                  const innerBtn = snippetBtn.querySelector('.button');
                  if (innerBtn) innerBtn.style.justifyContent = '';
                  snippetBtn.style.opacity = '';
                  snippetBtn.style.transform = '';
                  snippetBtn.classList.add('docked');
                  hideSpacer();
                  snippetBtn.getBoundingClientRect();
                  snippetBtn.style.transition = '';
                }, TRANSITION_MS);
              }
            }
          });
        },
        { threshold: 0 }
      );
      productWrapObserver.observe(productWrap);
    }
  }

  // Footer observer — slides the fixed button out when the footer enters the viewport
  const footerTarget = document.querySelector('#shopify-section-footer');
  if (footerTarget) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          document.body.classList.toggle('is-footer-visible', entry.isIntersecting);
          // Desktop: also slide the fixed bar out when footer appears
          if (snippetBtn && window.innerWidth >= 992) {
            if (entry.isIntersecting && !isDesktopAnimating && snippetBtn.classList.contains('fixed-add-to-cart-desktop')) {
              desktopSlideOut();
            }
          }
        });
      },
      { threshold: 0 }
    );
    footerObserver.observe(footerTarget);
  }
})();

function updateFixedButtons() {
  const body = document.querySelector("body");
  const footer = document.querySelector(".product-recommendations-head");
  const fallbackFooter = document.querySelector(".section-footer");
  const snippetBtn = document.querySelector(".snippet-addto-cart");
  const discoverBtn = document.querySelector(".discover-add-to-cart");

  if ((!footer && !fallbackFooter) || (!snippetBtn && !discoverBtn)) return;

  // use product-recommendations-head OR fallback section-footer
  const target = footer || fallbackFooter;

  const targetTop = target.getBoundingClientRect().top + window.scrollY;
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;

  if (scrollY + windowHeight >= targetTop) {
    body.classList.add("is-fixed");
  } else {
    body.classList.remove("is-fixed");
  }
}

updateFixedButtons();
window.addEventListener("scroll", updateFixedButtons);
